import { useEffect, useState } from "react";

export default function RotatingClusters({ lines, isPrompts} : {isPrompts: boolean, lines: {text: string, icon:React.ReactElement}[]}) {
  const [activeIndex, setActiveIndex] = useState(0);
  const time = isPrompts ? 4000 : 2000;

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % lines.length);
    }, time);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="space-y-5">
      {lines.map((line, index) => (
        <p
          key={index}
          className={`flex items-center gap-5 text-base transition-colors duration-700 ${
            index === activeIndex
              ? "text-[#fafafa]"
              : "text-[#737373]"
          }`}
        >
         {line.icon} {line.text}
        </p>
      ))}
    </div>
  );
}